import slugify from 'slugify'

export function slugifyText(text: string) {
    /** Remove quotes from text */
    const sanitizedText = text.replace(/&quot;/g, '')
    const result = slugify(sanitizedText, { lower: true, strict: true })

    if (result === '') {
        // This is likely text using a non-Latin alphabet. (Japanese, Chinese, Korean, etc.)
        // The default "remove" regex removes all non-Latin characters.
        // We'll replace the default regex with one that only removes special characters.
        // https://github.com/simov/slugify/issues/100
        return slugify(sanitizedText, { remove: /[$*_+~.()'"!\-:@]+/g })
    }

    return result
}
